import React from 'react';
import posthog from 'posthog-js';
import { PostHogProvider } from 'posthog-js/react';

const POSTHOG_KEY = import.meta.env.REACT_APP_POSTHOG_KEY;
const POSTHOG_HOST = import.meta.env.REACT_APP_POSTHOG_HOST;

if (POSTHOG_KEY) {
	posthog.init(POSTHOG_KEY, {
		api_host: POSTHOG_HOST,
		capture_pageview: false, // Manual tracking via usePageTracking — auto-capture fires before group context is set
	});
}

export const MaybePostHogProvider = ({ children }: { children: React.ReactNode }) => {
	if (POSTHOG_KEY) {
		return <PostHogProvider client={posthog}>{children}</PostHogProvider>;
	}
	return children as React.ReactElement;
};
